import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setViewData } from "../../../Reducer/DashboardReducer";
import logomain from "../../../images/logo-main.png";

export const ProductList = ({ Data }) => {
  const navigation = useNavigate();
  const dispatch = useDispatch();

  return (
    <>
      <li className="table-row">
        <div
          style={{ display: "flex", justifyContent: "center" }}
          className="col"
          data-label="Job Id"
        >
          <img
            src={Data?.app_logo ? Data?.app_logo : logomain}
            style={{ width: "37px", height: "37px", objectFit: "cover" }}
            alt="Logo"
          />
        </div>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "flex",
            justifyContent: "center",
            fontSize: "13px",
          }}
          className="col"
          data-label="Customer Name"
        >
          {Data?.app_name}
        </div>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "flex",
            justifyContent: "center",
            fontSize: "13px",
          }}
          className="col"
          data-label="Amount"
        >
          {Data?.client_id}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            fontSize: "13px",
          }}
          className="col"
          data-label="Payment Status"
        >
          {new Date(Data?.created_at).toLocaleDateString("en-US")}
        </div>
        <div
          className="col"
          style={{
            display: "flex",
            justifyContent: "center",
          }}
          data-label="Payment Status"
        >
          <button
            onClick={() => {
              navigation("/dashboard/app-view");
              dispatch(setViewData(Data));
            }}
            className="btn btn--primary"
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              fontSize: "13px",
            }}
          >
            <svg
              className="icon"
              width={13}
              height={13}
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <rect width={13} height={13} fill="url(#pattern0)" />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width={1}
                  height={1}
                >
                  <use xlinkHref="#image0_51_531" transform="scale(0.01)" />
                </pattern>
                <image
                  id="image0_51_531"
                  width={100}
                  height={100}
                  xlinkHref="data:image/png;base64,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"
                />
              </defs>
            </svg>
            View
          </button>
        </div>
      </li>
    </>
  );
};
